import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styled from "styled-components"

import api from "apis"
import { Box, Typography } from "components/common"
import { submit_ga_event_click } from "helpers/analytics-helpers"
import { jewlr_t } from "helpers/application"
import { instantGiftVideoData } from "helpers/holiday"

const VideoWrapper = styled.div`
  display: block;
  margin: 0 auto;
  position: relative;
  width: 100%;
  ${(props) => props.theme.mediaQueries.tablet`
    width: 504px;
  `}
  video {
    box-shadow: 4px 5px 6px -4px rgba(0, 0, 0, 0.55);
  }
`
const LoadingContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.55);
  height: calc(100% - 5px);
  left: 0;
  padding: 10% 8px 0;
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1;
  ${(props) => props.theme.mediaQueries.tablet`
    padding-top: 15%;
  `}
`

const PersonalizedVideo = ({ data }) => {
  const { video } = data
  const [videoUrl, setVideoUrl] = useState(
    video.check_status_url ? null : video.url
  )
  const thumbnail = instantGiftVideoData().video

  useEffect(() => {
    if (!videoUrl) {
      const generateVideo = async () => {
        try {
          // poll video status
          const checkStatusUrl = `/api/v4/line_items/video_status?id=${video.video_id}`
          let checkStatus = await api.get(checkStatusUrl)
          while (
            checkStatus.data &&
            ![
              "VIDEO_AVAILABLE",
              "ERROR",
              "FUNCTION_ERROR",
              "NOT_EXIST",
            ].includes(checkStatus.data.status)
          ) {
            await delay(1000)
            checkStatus = await api.get(checkStatusUrl)
          }

          // save video data after poll
          if (checkStatus.data.status === "VIDEO_AVAILABLE") {
            setVideoUrl(video.url)
          }
        } catch (e) {
          console.log(e)
        }
      }
      generateVideo()
    }
  }, [])

  return (
    <VideoWrapper>
      <video
        controls
        height="auto"
        onPlay={() => {
          submit_ga_event_click("Instant Gift", "Play Video")
        }}
        playsInline
        poster={`${sl.config.jewlr_asset_url}instant-gift/thumbnails/${thumbnail}.jpg`}
        width="100%"
      >
        {videoUrl && <source src={videoUrl} type="video/mp4" />}
      </video>
      {!videoUrl && (
        <LoadingContainer>
          <Typography
            color="white"
            fontSize={{ _: "14px", tablet: "16px" }}
            mb={2}
          >
            Your {jewlr_t("terms.personalized")} Gift Preview Video{" "}
            <Box as="br" display={{ _: "none", tablet: "block" }} />
            is being created and will be ready in just a few seconds!
          </Typography>
          <Box
            as="img"
            src={require("images/icons/generic_loading.gif")}
            width="35"
          />
        </LoadingContainer>
      )}
    </VideoWrapper>
  )
}

const delay = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

PersonalizedVideo.propTypes = {
  data: PropTypes.object,
}

export default PersonalizedVideo
